var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7696_11286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2933 8.7067C10.9026 8.31603 10.9026 7.68265 11.2933 7.29198L15.2933 3.29198C15.3853 3.19998 15.4961 3.12667 15.6188 3.076C15.8628 2.97467 16.1388 2.97467 16.3828 3.076C16.5055 3.12667 16.616 3.19998 16.708 3.29198L20.708 7.29198C21.0987 7.68265 21.0987 8.31603 20.708 8.7067C20.5133 8.90136 20.2573 8.99999 20.0013 8.99999C19.7453 8.99999 19.4893 8.9027 19.2946 8.7067L17.0013 6.41332V21.3333C17.0013 21.8853 16.5533 22.3333 16.0013 22.3333C15.4493 22.3333 15.0013 21.8853 15.0013 21.3333V6.41462L12.708 8.708C12.316 9.09733 11.684 9.09736 11.2933 8.7067ZM24 12.3333C23.448 12.3333 23 12.7813 23 13.3333C23 13.8853 23.448 14.3333 24 14.3333C26.1027 14.3333 27 15.2307 27 17.3333V24C27 26.1027 26.1027 27 24 27H8C5.89733 27 5 26.1027 5 24V17.3333C5 15.2307 5.89733 14.3333 8 14.3333C8.552 14.3333 9 13.8853 9 13.3333C9 12.7813 8.552 12.3333 8 12.3333C4.776 12.3333 3 14.1093 3 17.3333V24C3 27.224 4.776 29 8 29H24C27.224 29 29 27.224 29 24V17.3333C29 14.1093 27.224 12.3333 24 12.3333Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7696_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.9584f5f87fa304786ff77e5df6ec56ce.svg";
export { ForwardRef as ReactComponent };